const footerLinks = [
    /*
    {
        title: "How it Works",
        href: "/how"
    },
    */
    {
        title: "Privacy Policy",
        href: "/privacy-policy"
    },
    {
        title: "Terms & Conditions",
        href: "/terms-conditions"
    }
];

export default footerLinks;



// WEBPACK FOOTER //
// ./src/footerLinks.js